import api from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import useDataLoader from 'containers/dataLoader'
import { useSelector } from 'react-redux'
import { IOrganization } from 'types'

const useManualUpload = (organization: IOrganization) => {
  const token = useSelector(selectToken)
  const uploadFile = async (file: File, category: string) => {
    const formData = new FormData()
    formData.append('file', file)
    try {
      const res = await api.manualUpload(
        token,
        organization.id,
        formData,
        category
      )
      return res
    } catch (error: any) {
      // Manual-queries uploads return per-row validation messages — surface
      // them instead of the generic axios status text.
      const rowErrors = error?.response?.data?.detail?.errors
      if (Array.isArray(rowErrors) && rowErrors.length > 0) {
        throw new Error(rowErrors.join(' '))
      }
      throw error
    }
  }

  return useDataLoader(uploadFile)
}

export default useManualUpload
